import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import getContentItemType, { getContentItemTypeTranslationKey } from 'utils/asset/getContentItemType';
import { getContentItemIconFromType } from 'utils/icons';
import isMultiDomain from 'utils/isMultiDomain';
import getPictureUrl, { DIMENSIONS } from 'utils/image/getPictureUrl';
import { ASSET_READ, PLAYLIST_WRITE, getCanMembersContribute, hasPrivilege, isTeamManager } from 'utils/privileges';
import config from 'utils/config';
import { BASIC } from 'styles/spacingPresets';
import Box from 'components/Box';
import Card from 'components/Card';
import Flex from 'components/Flex';
import Heading from 'components/Heading';
import { SelectableContentCard, SelectableSection, SelectableSectionChildren, SelectableSectionWrapper } from 'components/ContentCards';
import Stack from 'components/Stack';
import useBreakpoints from 'hooks/useBreakpoints';
import useModalQueryParam from 'hooks/useModalQueryParam';
import useSearchParams from 'hooks/useSearchParams';
import PlaylistEditorModal from 'screens/PlaylistEditorModal';
import AssetManager from 'screens/AssetManager';
import { sessionQueryParameterValues } from 'screens/EventSessionsManager';
import SectionEditorModalUi from 'screens/SectionEditorModalUi';
import { checkIsValidMoveTarget } from './utils/checkIsValidMoveTarget';
import { formatPlaylistEditorPayload } from './utils/formatPlaylistEditorPayload';
import { Toolbar } from './components/Toolbar';
import { FloatingButtonLayout } from './components/FloatingButtonLayout';
import { Menu, AddContentMenuList } from './components/AddContentMenu';
import { EditableSectionContentInfo } from './components/EditableSectionContentInfo';
import { FloatingMoveButton, FloatingAddSectionButton, FloatingAddContentButton } from './components/FloatingButtons';
import { PrimaryAddContentButton, PrimaryAddSectionButton, PrimaryMoveButton } from './components/PrimaryButtons';
import { useContentManagerSelection } from './useContentManagerSelection';
import { checkIsItemEditable } from './utils/checkIsItemEditable';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PlaylistManageContentEditor(_ref) {
  var contentAsTree = _ref.contentAsTree,
    reducerState = _ref.reducerState,
    playlist = _ref.playlist,
    stickyHeaderCompensation = _ref.stickyHeaderCompensation,
    hasPlaylistChanges = _ref.hasPlaylistChanges;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useBreakpoints = useBreakpoints('xs'),
    isDesktop = _useBreakpoints.xs;
  var _useModalQueryParam = useModalQueryParam('edit-content'),
    _useModalQueryParam2 = _slicedToArray(_useModalQueryParam, 2),
    hasOpenedEditor = _useModalQueryParam2[0],
    toggleOpenEditor = _useModalQueryParam2[1];
  var hasPlaylistNumbering = playlist.hasPlaylistNumbering;
  var isPlaylistDistributed = isMultiDomain(playlist);
  var _reducerState = _slicedToArray(reducerState, 2),
    _reducerState$ = _reducerState[0],
    content = _reducerState$.content,
    mobileInteractionMode = _reducerState$.mobileInteractionMode,
    dispatch = _reducerState[1];
  var isMovingEnabled = !isPlaylistDistributed && (isDesktop || mobileInteractionMode === 'move');
  var canCreateAsset = useMemo(function () {
    return hasPrivilege(ASSET_READ) || !!(config.managersCreateAssets && playlist.ownerTeamId && isTeamManager(playlist.ownerTeamId)) || !!getCanMembersContribute(playlist);
  }, [playlist]);
  var isPlaylistAdminOrTeamManager = useMemo(function () {
    return hasPrivilege(PLAYLIST_WRITE) || !!(config.enableTeamPlaylists && playlist.ownerTeamId && isTeamManager(playlist.ownerTeamId));
  }, [playlist]);
  var availableAddContentOptions;
  if (canCreateAsset && isPlaylistAdminOrTeamManager) {
    availableAddContentOptions = 'all';
  } else if (canCreateAsset) {
    availableAddContentOptions = 'new-only';
  } else if (isPlaylistAdminOrTeamManager) {
    availableAddContentOptions = 'existing-only';
  }
  var canAddOrMoveContent = !isPlaylistDistributed;
  var _useContentManagerSel = useContentManagerSelection({
      content: content,
      contentAsTree: contentAsTree
    }),
    hasSelectedItems = _useContentManagerSel.hasSelectedItems,
    selectedItemIds = _useContentManagerSel.selectedItemIds,
    selectedItems = _useContentManagerSel.selectedItems,
    clearSelection = _useContentManagerSel.clearSelection,
    setSelectedItemIds = _useContentManagerSel.setSelectedItemIds,
    getSelectRowHandler = _useContentManagerSel.getSelectRowHandler,
    getHighlightRowHandler = _useContentManagerSel.getHighlightRowHandler,
    getSelectSingleRowHandler = _useContentManagerSel.getSelectSingleRowHandler,
    handleGridSelectionKeys = _useContentManagerSel.handleGridSelectionKeys;
  function moveSelectedItems(_ref2) {
    var ids = _ref2.ids,
      targetRankInSection = _ref2.targetRankInSection,
      targetParentId = _ref2.targetParentId;
    dispatch({
      type: 'MOVE_CONTENT',
      ids: ids,
      targetRankInSection: targetRankInSection,
      targetParentId: targetParentId
    });
    clearSelection();
  }
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    itemIdsToEdit = _useState2[0],
    setItemIdsToEdit = _useState2[1];
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 2),
    searchParams = _useSearchParams2[0],
    setSearchParams = _useSearchParams2[1];
  var clearEditorRoutingParams = useCallback(function () {
    var clearedSessionParams = {};
    var _iterator = _createForOfIteratorHelper(sessionQueryParameterValues),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var paramName = _step.value;
        clearedSessionParams[paramName] = undefined;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    setSearchParams(function (oldParams) {
      return _objectSpread(_objectSpread({}, oldParams), {}, {
        tab: undefined,
        modal: undefined
      }, clearedSessionParams);
    });
  }, [setSearchParams]);
  var hasSessionRoutingParams = sessionQueryParameterValues.some(function (paramName) {
    return Boolean(searchParams[paramName]);
  });
  var closeItemsEditor = function closeItemsEditor() {
    if (hasOpenedEditor || hasSessionRoutingParams) {
      clearEditorRoutingParams();
    } else {
      toggleOpenEditor();
    }
  };
  useEffect(function () {
    // Keep ids while the modal query is still open. This avoids unmounting
    // the editor when navigation is blocked (e.g. unsaved-changes blocker).
    if (!hasOpenedEditor && itemIdsToEdit.length > 0) {
      setItemIdsToEdit([]);
    }
  }, [hasOpenedEditor, itemIdsToEdit]);
  var isEditingMultiple = itemIdsToEdit.length > 1;
  var itemsToEdit = isEditingMultiple ? itemIdsToEdit.map(function (id) {
    return content.find(function (item) {
      return item.id === id;
    });
  }) : content.find(function (item) {
    return item.id === itemIdsToEdit[0];
  });
  var editorType;
  if (itemsToEdit && !Array.isArray(itemsToEdit)) {
    if (itemsToEdit.type === 'section' || itemsToEdit.type === 'playlist') {
      editorType = itemsToEdit.type;
    } else {
      editorType = 'asset';
    }
  } else if (itemsToEdit && (itemsToEdit === null || itemsToEdit === void 0 ? void 0 : itemsToEdit.length) > 1) {
    editorType = 'asset';
  }
  useEffect(function () {
    // On refresh, `modal=edit-content` can persist in the URL while there is
    // no selected item to edit, which leaves the UI and URL out of sync.
    // In that case, clear modal/tab params so the toggle state is reset.
    if (hasOpenedEditor && itemIdsToEdit.length === 0) {
      clearEditorRoutingParams();
    }
  }, [hasOpenedEditor, itemIdsToEdit.length, clearEditorRoutingParams]);
  function submitMultiAssetEditor(_x) {
    return _submitMultiAssetEditor.apply(this, arguments);
  }
  function _submitMultiAssetEditor() {
    _submitMultiAssetEditor = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(changesPerItem) {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(itemIdsToEdit.length <= 1)) {
              _context.next = 1;
              break;
            }
            return _context.abrupt("return");
          case 1:
            dispatch({
              type: 'UPDATE_CONTENT',
              data: changesPerItem.map(function (_ref5) {
                var changes = _ref5.changes,
                  id = _ref5.id;
                return _objectSpread({
                  id: id
                }, changes);
              })
            });
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _submitMultiAssetEditor.apply(this, arguments);
  }
  function submitAssetEditor(_x2) {
    return _submitAssetEditor.apply(this, arguments);
  }
  function _submitAssetEditor() {
    _submitAssetEditor = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
      var changes, patch;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            changes = _ref3.changes;
            if (!(itemIdsToEdit.length !== 1)) {
              _context2.next = 1;
              break;
            }
            return _context2.abrupt("return");
          case 1:
            patch = _objectSpread({
              id: itemIdsToEdit[0]
            }, changes);
            dispatch({
              type: 'UPDATE_CONTENT',
              data: patch
            });
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _submitAssetEditor.apply(this, arguments);
  }
  function submitPlaylistEditor(_x3) {
    return _submitPlaylistEditor.apply(this, arguments);
  }
  function _submitPlaylistEditor() {
    _submitPlaylistEditor = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(changes) {
      var data;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(itemIdsToEdit.length !== 1)) {
              _context3.next = 1;
              break;
            }
            return _context3.abrupt("return");
          case 1:
            data = formatPlaylistEditorPayload(itemIdsToEdit[0], changes);
            dispatch({
              type: 'UPDATE_CONTENT',
              data: data
            });
            closeItemsEditor();
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return _submitPlaylistEditor.apply(this, arguments);
  }
  function submitSectionEditor(_x4) {
    return _submitSectionEditor.apply(this, arguments);
  }
  function _submitSectionEditor() {
    _submitSectionEditor = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(changes) {
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (!(itemIdsToEdit.length !== 1)) {
              _context4.next = 1;
              break;
            }
            return _context4.abrupt("return");
          case 1:
            dispatch({
              type: 'UPDATE_CONTENT',
              data: _objectSpread({
                id: itemIdsToEdit[0]
              }, changes)
            });
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _submitSectionEditor.apply(this, arguments);
  }
  function _onRequestEdit(ids) {
    setItemIdsToEdit(ids);
    toggleOpenEditor();
  }
  var _renderTree = function renderTree(_ref4) {
    var _itemsAtThisLevel$at, _content$find;
    var itemsAtThisLevel = _ref4.itemTree,
      parentId = _ref4.parentId,
      _ref4$level = _ref4.level,
      level = _ref4$level === void 0 ? 0 : _ref4$level,
      _ref4$path = _ref4.path,
      path = _ref4$path === void 0 ? [] : _ref4$path,
      _ref4$isParentSelecte = _ref4.isParentSelected,
      isParentSelected = _ref4$isParentSelecte === void 0 ? false : _ref4$isParentSelecte,
      name = _ref4.name;
    if (itemsAtThisLevel.length === 0) {
      if (!canAddOrMoveContent) {
        return null;
      }
      var canMoveHere = checkIsValidMoveTarget({
        isMovingEnabled: isMovingEnabled,
        content: content,
        selectedItemIds: selectedItemIds,
        targetRankInSection: 0,
        targetParentId: parentId
      });
      return /*#__PURE__*/_jsx(Flex, {
        border: "dashed",
        borderRadius: "small",
        p: "xs",
        minHeight: 75 // average content card height
        ,
        children: canMoveHere ? /*#__PURE__*/_jsx(PrimaryMoveButton, {
          size: "default",
          onClick: function onClick() {
            return moveSelectedItems({
              ids: selectedItemIds,
              targetRankInSection: 0,
              targetParentId: parentId
            });
          },
          name: name
        }) : /*#__PURE__*/_jsxs(Menu, {
          children: [/*#__PURE__*/_jsx(PrimaryAddContentButton, {
            size: "default",
            name: name
          }), /*#__PURE__*/_jsx(AddContentMenuList, {
            dispatch: dispatch,
            targetParentId: parentId,
            targetRankInSection: 0,
            canAddSection: level < 2,
            availableOptions: availableAddContentOptions
          })]
        })
      });
    }
    var firstSectionIndex = itemsAtThisLevel.findIndex(function (item) {
      return item.type === 'section';
    });
    var isSectionList = firstSectionIndex > -1;
    var rankAfterLastItem = (((_itemsAtThisLevel$at = itemsAtThisLevel.at(-1)) === null || _itemsAtThisLevel$at === void 0 ? void 0 : _itemsAtThisLevel$at.rankInSection) || 0) + 1;
    var canMoveToEndOfList = checkIsValidMoveTarget({
      isMovingEnabled: isMovingEnabled,
      content: content,
      selectedItemIds: selectedItemIds,
      targetRankInSection: rankAfterLastItem,
      targetParentId: parentId
    });

    // When there's a selection, we're hiding any floating '+' buttons
    // to make it easier to see available move targets
    var hasFloatingAddButtons = !hasSelectedItems;
    var subsectionName = (_content$find = content.find(function (item) {
      return item.id === parentId;
    })) === null || _content$find === void 0 ? void 0 : _content$find.name;
    return /*#__PURE__*/_jsxs(Stack, {
      spacing: BASIC.SMALL,
      breakpoints: BASIC.BREAKPOINTS,
      children: [itemsAtThisLevel.map(function (item, index) {
        var id = item.id,
          itemParentId = item.parent_id,
          rankInSection = item.rankInSection,
          name = item.name,
          description = item.description,
          type = item.type,
          children = item.children;
        var isContentEditable = checkIsItemEditable({
          item: item,
          isParentPlaylistDistributed: isPlaylistDistributed,
          parentPlaylistMemberContributions: playlist.allow_member_contributions,
          parentPlaylistOwnerTeamId: playlist.ownerTeamId
        });
        var isFirstSection = index === firstSectionIndex;
        var currentPath = [].concat(_toConsumableArray(path), [index + 1]);
        var itemNumber = currentPath.join('.');
        if (type === 'section') {
          var isSectionSelected = selectedItemIds.includes(id);
          var renderedChildren = _renderTree({
            itemTree: children,
            parentId: id,
            level: level + 1,
            path: currentPath,
            isParentSelected: isParentSelected || isSectionSelected,
            name: name
          });
          var _canMoveHere = checkIsValidMoveTarget({
            isMovingEnabled: isMovingEnabled,
            content: content,
            selectedItemIds: selectedItemIds,
            targetRankInSection: rankInSection,
            targetParentId: parentId
          });
          return /*#__PURE__*/_jsxs(SelectableSectionWrapper, {
            isSelected: isSectionSelected && !isParentSelected,
            children: [/*#__PURE__*/_jsx(FloatingButtonLayout, {
              hideButtons: !canAddOrMoveContent,
              showWhenNotHovered: _canMoveHere,
              buttonOffset: -15,
              button: _canMoveHere ? /*#__PURE__*/_jsx(FloatingMoveButton, {
                onClick: function onClick() {
                  return moveSelectedItems({
                    ids: selectedItemIds,
                    targetRankInSection: rankInSection,
                    targetParentId: parentId
                  });
                },
                name: name,
                level: level
              }) : isFirstSection && hasFloatingAddButtons ? /*#__PURE__*/_jsxs(Menu, {
                children: [/*#__PURE__*/_jsx(FloatingAddContentButton, {
                  name: name,
                  level: level
                }), /*#__PURE__*/_jsx(AddContentMenuList, {
                  canAddSection: true,
                  dispatch: dispatch,
                  targetParentId: parentId,
                  targetRankInSection: rankInSection,
                  availableOptions: availableAddContentOptions
                })]
              }) : hasFloatingAddButtons && isPlaylistAdminOrTeamManager && /*#__PURE__*/_jsx(FloatingAddSectionButton, {
                onClick: function onClick() {
                  return dispatch({
                    type: 'REQUEST_NEW_CONTENT',
                    variant: 'new-section',
                    targetParentId: parentId,
                    targetRankInSection: rankInSection
                  });
                },
                name: name,
                level: level
              }),
              children: /*#__PURE__*/_jsx(SelectableSection, {
                isSectionEditable: isContentEditable && isPlaylistAdminOrTeamManager,
                name: name,
                description: description,
                number: itemNumber,
                isSelected: isSectionSelected,
                isSelectionDisabled: isParentSelected,
                onToggleSelection: getSelectRowHandler(id),
                onClick: getSelectSingleRowHandler(id),
                onMouseOver: getHighlightRowHandler(id),
                onRequestEdit: function onRequestEdit() {
                  return _onRequestEdit([id]);
                },
                contentInfo: /*#__PURE__*/_jsx(EditableSectionContentInfo, {
                  section: item
                }),
                hasPlaylistNumbering: hasPlaylistNumbering
              })
            }), /*#__PURE__*/_jsx(SelectableSectionChildren, {
              children: renderedChildren
            })]
          }, id);
        } else {
          var _canMoveHere2 = checkIsValidMoveTarget({
            isMovingEnabled: isMovingEnabled,
            content: content,
            selectedItemIds: selectedItemIds,
            targetRankInSection: rankInSection,
            targetParentId: itemParentId
          });
          var basicContentType = getContentItemType(item);
          var translatableType = getContentItemTypeTranslationKey(basicContentType);
          var icon = getContentItemIconFromType(basicContentType);
          var isDistributed = isMultiDomain(item);
          return /*#__PURE__*/_jsx(FloatingButtonLayout, {
            buttonOffset: "-s",
            showWhenNotHovered: _canMoveHere2,
            hideButtons: !canAddOrMoveContent,
            button: _canMoveHere2 ? /*#__PURE__*/_jsx(FloatingMoveButton, {
              onClick: function onClick() {
                return moveSelectedItems({
                  ids: selectedItemIds,
                  targetParentId: parentId,
                  targetRankInSection: rankInSection
                });
              },
              name: name,
              level: level
            }) : hasFloatingAddButtons && /*#__PURE__*/_jsxs(Menu, {
              children: [/*#__PURE__*/_jsx(FloatingAddContentButton, {
                name: name,
                level: level
              }), /*#__PURE__*/_jsx(AddContentMenuList, {
                canAddSection: level < 2,
                dispatch: dispatch,
                targetParentId: parentId,
                targetRankInSection: rankInSection,
                availableOptions: availableAddContentOptions
              })]
            }),
            children: /*#__PURE__*/_jsx(SelectableContentCard, {
              isContentEditable: isContentEditable,
              title: name,
              translatedType: t(translatableType),
              type: item.type,
              icon: icon,
              isOptional: item.optional,
              number: itemNumber,
              changesCount: item.changedFields.size,
              imageSource: getPictureUrl({
                id: item.thumbnailId,
                dimensions: DIMENSIONS.HORIZONTAL_CARD
              }),
              isSelected: selectedItemIds.includes(id),
              isSelectionDisabled: isParentSelected,
              onToggleSelection: getSelectRowHandler(id),
              onClick: getSelectSingleRowHandler(id),
              onMouseOver: getHighlightRowHandler(id),
              onRequestEdit: function onRequestEdit() {
                return _onRequestEdit([id]);
              },
              isDistributed: isDistributed,
              fileId: 'fileId' in item ? item.fileId : undefined,
              contentFileStatus: 'fileStatus' in item ? item.fileStatus : undefined,
              hasPlaylistNumbering: hasPlaylistNumbering
            })
          }, id);
        }
      }), canAddOrMoveContent && (canMoveToEndOfList ? /*#__PURE__*/_jsx(PrimaryMoveButton, {
        onClick: function onClick() {
          return moveSelectedItems({
            ids: selectedItemIds,
            targetParentId: parentId,
            targetRankInSection: rankAfterLastItem
          });
        },
        name: subsectionName
      }) : isSectionList ? isPlaylistAdminOrTeamManager && /*#__PURE__*/_jsx(PrimaryAddSectionButton, {
        level: level,
        onClick: function onClick() {
          return dispatch({
            type: 'REQUEST_NEW_CONTENT',
            variant: 'new-section',
            targetParentId: parentId,
            targetRankInSection: rankAfterLastItem
          });
        },
        name: subsectionName
      }) : /*#__PURE__*/_jsxs(Menu, {
        children: [/*#__PURE__*/_jsx(PrimaryAddContentButton, {
          name: subsectionName
        }), /*#__PURE__*/_jsx(AddContentMenuList, {
          canAddSection: level < 2,
          dispatch: dispatch,
          targetParentId: parentId,
          targetRankInSection: rankAfterLastItem,
          availableOptions: availableAddContentOptions
        })]
      }))]
    });
  };
  return /*#__PURE__*/_jsxs(Card, {
    px: BASIC.LARGE,
    py: BASIC.MEDIUM,
    breakpoints: BASIC.BREAKPOINTS,
    overflow: "visible",
    onKeyDown: handleGridSelectionKeys,
    children: [/*#__PURE__*/_jsx(Heading, {
      as: "h2",
      children: t('actions_manage_content')
    }), /*#__PURE__*/_jsxs(Box, {
      position: "relative",
      mt: BASIC.MEDIUM,
      breakpoints: BASIC.BREAKPOINTS,
      children: [/*#__PURE__*/_jsx(Toolbar, {
        selectedItems: selectedItems,
        selectedItemIds: selectedItemIds,
        clearSelection: clearSelection,
        setSelectedItemIds: setSelectedItemIds,
        reducerState: reducerState,
        onRequestEdit: _onRequestEdit,
        stickyHeaderCompensation: stickyHeaderCompensation,
        playlist: playlist
      }), /*#__PURE__*/_jsx(Stack, {
        spacing: "m",
        mt: BASIC.MEDIUM,
        ml: mobileInteractionMode === 'move' ? 'm' : undefined,
        breakpoints: BASIC.BREAKPOINTS,
        children: _renderTree({
          itemTree: contentAsTree
        })
      }), editorType === 'section' && /*#__PURE__*/_jsx(SectionEditorModalUi, {
        initialSectionData: itemsToEdit,
        onSubmit: submitSectionEditor,
        onClose: closeItemsEditor,
        inContentManagerContext: true
      }), editorType === 'asset' && hasOpenedEditor && /*#__PURE__*/_jsx(AssetManager, {
        inContentManagerContext: true,
        hasPlaylistChanges: hasPlaylistChanges,
        assets: isEditingMultiple ? itemsToEdit : [itemsToEdit],
        parentPlaylist: playlist,
        onClose: closeItemsEditor,
        onSubmit: isEditingMultiple ? submitMultiAssetEditor : submitAssetEditor
      }), editorType === 'playlist' && /*#__PURE__*/_jsx(PlaylistEditorModal, {
        playlist: itemsToEdit,
        onSubmit: submitPlaylistEditor,
        onClose: closeItemsEditor,
        inContentManagerContext: true
      })]
    })]
  });
}